<p>
PIE CHART EXAMPLE
</p>
<svg [attr.height]="radius* 2 + 10" [attr.width]="radius * 2">
  <g [attr.transform]="'translate('+ radius +', '+ radius +')'">
    <g *ngFor="let path of paths; let i = index">
      <path [attr.d]="path" [style.fill]="color(i)"></path>
    </g>
  </g>
</svg>